<template>
  <section>
    <div class="hero is-medium background-light">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-1">Photos</h1>
        </div>
      </div>
    </div>
    <div class="grid gallery background-light">
      <div class="grid-sizer"></div>
      <div class="grid-item background-light" v-for="(photo, index) in engagementPhotos" :key="index">
        <a :href="'../static/images/engagement-photos/' + photo"
           data-caption="Credit <a class='is-link' href='https://www.facebook.com/aowensphotos' target='_blank'>A. Owens Photography</a">
          <img :src="'../static/images/engagement-photos/small/' + photo">
        </a>
      </div>
      <div class="gutter-sizer"></div>
    </div>
  </section>
</template>

<script>
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd'
import baguetteBox from 'baguettebox.js'

import 'baguettebox.js/dist/baguetteBox.min.css'

export default {
  name: 'test.vue',
  data () {
    return {
      engagementPhotos: [
        'LauraJohn-1.jpg',
        'LauraJohn-2.jpg',
        'LauraJohn-3.jpg',
        'LauraJohn-4.jpg',
        'LauraJohn-5.jpg',
        'LauraJohn-6.jpg',
        'LauraJohn-7.jpg',
        'LauraJohn-8.jpg',
        'LauraJohn-9.jpg',
        'LauraJohn-10.jpg',
        'LauraJohn-11.jpg',
        'LauraJohn-12.jpg',
        'LauraJohn-13.jpg',
        'LauraJohn-14.jpg',
        'LauraJohn-15.jpg',
        'LauraJohn-16.jpg',
        'LauraJohn-17.jpg',
        'LauraJohn-18.jpg',
        'LauraJohn-19.jpg',
        'LauraJohn-20.jpg',
        'LauraJohn-21.jpg',
        'LauraJohn-22.jpg',
        'LauraJohn-23.jpg',
        'LauraJohn-24.jpg',
        'LauraJohn-25.jpg',
        'LauraJohn-26.jpg',
        'LauraJohn-27.jpg',
        'LauraJohn-28.jpg',
        'LauraJohn-29.jpg',
        'LauraJohn-30.jpg',
        'LauraJohn-31.jpg',
        'LauraJohn-32.jpg'
      ]
    }
  },
  mounted: () => {
    const grid = document.querySelector('.grid')

    const msnry = new Masonry(grid, {
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true
    })

    imagesLoaded(grid).on('progress', () => {
      msnry.layout()
    })
    baguetteBox.run('.gallery', {
      // Custom options
    })
  }
}
</script>

<style scoped lang="scss">
  @import "~bulma";

  * {
    box-sizing: border-box;
  }

  /* force scrollbar */
  html {
    overflow-y: scroll;
  }

  body {
    font-family: sans-serif;
  }

  /* ---- grid ---- */
  .grid {
  }

  /* clear fix */
  .grid:after {
    content: '';
    display: block;
    clear: both;
  }

  /* ---- .grid-item ---- */
  .grid-sizer,
  .grid-item {
    width: calc(25% - (2px * 3 / 4));
  }

  .grid-item {
    margin-bottom: 2px;
  }

  .gutter-sizer {
    width: 2px;
  }

  @include fullhd {
    .grid-sizer,
    .grid-item {
      width: calc((100% / 5) - (2px * 4 / 5))
    }
  }

  @include tablet-only {
    .grid-sizer,
    .grid-item {
      width: calc((100% / 3) - (2px * 2 / 3))
    }
  }

  @include mobile {
    .grid-sizer,
    .grid-item {
      width: calc(50% - (2px / 2))
    }
  }

  .grid-item {
    float: left;
  }

  .grid-item img {
    display: block;
    width: 100%;
    height: 100%;
  }

</style>
